import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { OuterWrapper, SuccessPageWrapper, Wrapper } from '../styles';
import { APPROVE_NEW_ICON } from '@Images';
import { SUCCESS_PAGE } from '../utils';
import { ACKNOWLEDGED, APPROVED, DASHBOARD_URL, TRANSFER_MONEY_URL } from '@Utils/constants';
import { CommonButton } from '@Components';
import { AppDispatch } from '../../../../store.type';
import { remitterPersonalInfo } from '@Redux/actions/user-status/user-status-action';
import { activateLoader, disableLoader } from '@Redux/actions/ui-trigger';

interface SuccessPageProps {
  // always shows the not-approved (manual review) content, whatever the user's status is
  manualFlowAlways?: boolean;
}

const SuccessPage: React.FC<SuccessPageProps> = ({ manualFlowAlways = false }) => {
  const navigate = useNavigate();
  const [userStatus, setUserStatus] = useState(ACKNOWLEDGED);
  const isApproved = !manualFlowAlways && userStatus === APPROVED;
  const data = isApproved ? SUCCESS_PAGE.APPROVED : SUCCESS_PAGE.ACKNOWLEDGED;
  const dispatch = useDispatch<AppDispatch>();

  const fetchRemitterPersonalInfo = async () => {
    dispatch(activateLoader());
    const response = await dispatch(remitterPersonalInfo());
    if (response?.data?.data?.status === APPROVED) setUserStatus(response?.data?.data?.status);
    dispatch(disableLoader());
  };

  useEffect(() => {
    if (!manualFlowAlways) fetchRemitterPersonalInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const redirectToSendMoney = () => {
    navigate(TRANSFER_MONEY_URL);
  };
  const redirectToDashboard = () => {
    navigate(DASHBOARD_URL);
  };

  return (
    <SuccessPageWrapper>
      <OuterWrapper>
        <Wrapper>
          <div>
            <img src={APPROVE_NEW_ICON} alt="Success Ico" className="userImg" />
          </div>
          <div className="heading">{data.heading}</div>
          <div className={`subHeading ${isApproved ? 'bottomMargin16' : 'bottomMargin48'}`}>
            {data.description}
          </div>

          {isApproved && (
            <div className="primaryButton bottomMargin24">
              <CommonButton text={data.primaryButton} onClick={redirectToSendMoney} />
            </div>
          )}
          <CommonButton type="link" text={data.secondaryButton} onClick={redirectToDashboard} />
        </Wrapper>
      </OuterWrapper>
    </SuccessPageWrapper>
  );
};

export default SuccessPage;
